// extracted by mini-css-extract-plugin
export default {"goal-items__time":"Countdown_goal-items__time__mzWsS","goal-items__time-low":"Countdown_goal-items__time-low__2HC3e","wiggle":"Countdown_wiggle__6Z3EQ"};